import { createFileRoute } from "@tanstack/react-router";
import Apply from "@/pages/Apply";
import ProtectedRoute from "@/components/ProtectedRoute";

export const Route = createFileRoute("/apply")({
  component: () => (
    <ProtectedRoute>
      <Apply />
    </ProtectedRoute>
  ),
});
